import React, { useState } from 'react'

import {
  ProgressBar,
  Accordion,
  useAccordionButton as useAccordionToggle,
  Col,
} from 'react-bootstrap'

import FormText from 'src/components/inputs/FormTextField/FormText'
import IconImg from 'src/components/buttons/IconImg'
import IconFilter from 'src/assets/v2/icon-filter.svg'
import BarcodeScanner from 'src/assets/v2/barcode-scanner.svg'
import { getCleanString } from 'src/utils/utilitiesV2'

function CustomToggle({
  eventKey,
  search,
  placeholder,
  onChange,
  style,
  igStyle,
  mt,
  setValue,
  onScan,
  loading,
  append,
  customFilter,
  showScannerButton = true,
  mainStyle,
}) {
  const decoratedOnClick = useAccordionToggle(eventKey, () => undefined)

  return (
    <div className={'column'} style={{ ...mainStyle }}>
      <FormText
        placeholder={placeholder || 'Buscar...'}
        style={{ ...style }}
        id={'filter'}
        value={search}
        onChange={onChange}
        append={
          customFilter ? (
            <IconImg
              icon={IconFilter}
              tooltip={'Filtrar'}
              onClick={() => {
                decoratedOnClick()
                setValue(0)
              }}
            />
          ) : append ? (
            append
          ) : null
        }
        prepend={
          onScan && showScannerButton ? (
            <IconImg
              icon={BarcodeScanner}
              placement={'top'}
              tooltip={'Escanear codigos de barra'}
              onClick={() => {
                decoratedOnClick()
                setValue(1)
              }}
            />
          ) : null
        }
        aPadding
        igStyle={igStyle}
        mt={mt}
      />

      {loading && (
        <div className={'pb-custom'}>
          <ProgressBar label="Cargando" animated now={100} style={{ marginBottom: 10 }} />
        </div>
      )}
    </div>
  )
}

let interval = null

const CustomFilter = props => {
  const [value, setValue] = useState(0)

  const { pageSelect, pageSelectLeft, pageSize = 4, minSize = 12 } = props

  const onScan = () => {
    return (
      <div className={'mt-2'}>
        <FormText
          style={{ width: 300 }}
          label={'Búsqueda por código de barra'}
          placeholder={'Clickeame! :D'}
          onChange={e => {
            const target = e.target
            const { value } = e.target
            clearInterval(interval)
            interval = setTimeout(() => {
              target.select()
              props.onScan(getCleanString(value))
            }, 600)
          }}
        />
      </div>
    )
  }

  const pageSelectContent = pageSelect && (
    <Col xl={pageSize} lg={pageSize} md={pageSize} sm={minSize} xs={minSize}>
      {pageSelect}
    </Col>
  )

  const minSizeToCustomToggle = pageSelect ? 12 - pageSize : 12
  const minSizeSmallToCustomToggle = pageSelect ? 12 - minSize : 12

  return (
    <Accordion defaultActiveKey={props.defaultActive ? '0' : '1'}>
      {pageSelectLeft && pageSelectContent}
      <Col
        xl={minSizeToCustomToggle}
        lg={minSizeToCustomToggle}
        md={minSizeToCustomToggle}
        sm={minSizeSmallToCustomToggle}
        xs={minSizeSmallToCustomToggle}>
        <CustomToggle
          {...props}
          eventKey={'0'}
          placeholder={props.placeholder}
          onChange={props.onChange}
          search={props.search}
          setValue={v => setValue(v)}
          loading={props.loading}
          customFilter={props.customFilter}
        />
      </Col>
      {!pageSelectLeft && pageSelectContent}
      <Col xs={12} sm={0} md={12}>
        <Accordion.Collapse eventKey={'0'}>
          {value === 0 ? props.customFilter ? props.customFilter : <></> : onScan()}
        </Accordion.Collapse>
      </Col>
    </Accordion>
  )
}
export default CustomFilter
